import React from 'react';

const Footer = () => (
  <footer className="bg-light py-4 text-center">
    <p className="mb-0">&copy; {new Date().getFullYear()} Reem Khalifa Aladawi. All rights reserved.</p>
  </footer>
);

export default Footer;
